import { render, staticRenderFns } from "./order_perfect2.vue?vue&type=template&id=3876a245&scoped=true"
import script from "./order_perfect2.vue?vue&type=script&lang=js"
export * from "./order_perfect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876a245",
  null
  
)

export default component.exports